import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import { useEffect, useState } from "react";
import { options } from "./HighchartComponentOptions";
import { HighchartComponentProps } from "./HighchartComponentTypes";
import { TFundsDataModel, TPortfolioModelFundCart } from "../../types/SavePlansTypes";

const HighchartComponent: React.FC<HighchartComponentProps> = ({modelWallet}) =>
{
    const [series, setSeries] = useState<TFundsDataModel[]>([])
    const DataSeries = () =>
    {
        let seriesData: TFundsDataModel[] = [];

        if(modelWallet.fundsData && modelWallet.fundsData.length > 0)
        {
            modelWallet.fundsData.forEach((funds: TPortfolioModelFundCart) =>
            {
                seriesData.push(
                {
                    name: funds.fund.name,
                    data: [Number(funds.modelPercentage.toFixed(2))]
                });
            });
        }

        setSeries(seriesData);
    }

    useEffect(() =>
    {
        DataSeries()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelWallet]);

    return(
        <HighchartsReact highcharts={Highcharts}
            options={
            {
                ...options,
                series: series,
            }}
        />
    );
};

export default HighchartComponent;